"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveConfirmationChecklist = exports.PageStateChecklist = void 0;
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ListItem;
(function (ListItem) {
    ListItem["ANYONE_CAN_ACCESS"] = "ANYONE_CAN_ACCESS";
    ListItem["ACTIVITY_TRACKING"] = "ACTIVITY_TRACKING";
    ListItem["EDITABLE"] = "EDITABLE";
})(ListItem || (ListItem = {}));
var MapListItemToProps = (_a = {},
    _a[ListItem.ANYONE_CAN_ACCESS] = function (ticked) {
        if (ticked) {
            return {
                description: "share link will be accessible",
                icon: react_1.default.createElement(icons_1.Link, null),
            };
        }
        else {
            return {
                description: "share link won’t be accessible",
                icon: react_1.default.createElement(icons_1.Unlink, null),
            };
        }
    },
    _a[ListItem.ACTIVITY_TRACKING] = function (ticked) {
        if (ticked) {
            return {
                description: "share link will track activity",
                icon: react_1.default.createElement(icons_1.Analytics, null),
            };
        }
        else {
            return {
                description: "share link won’t track activity",
                icon: react_1.default.createElement(icons_1.NoAnalytics, null),
            };
        }
    },
    _a[ListItem.EDITABLE] = function (ticked) {
        if (ticked) {
            return {
                description: "page still editable",
                icon: react_1.default.createElement(icons_1.Edit, null),
            };
        }
        else {
            return {
                description: "page will not be editable",
                icon: react_1.default.createElement(icons_1.NoEdit, null),
            };
        }
    },
    _a);
var pageStateChecklist = (0, BemBuilder_1.default)("page-state-checklists");
var PageStateChecklist = function (_a) {
    var pageStatus = _a.pageStatus;
    var isTickedList = {};
    switch (pageStatus) {
        case Types_1.ProjectStatus.Live:
            isTickedList[ListItem.ANYONE_CAN_ACCESS] = true;
            isTickedList[ListItem.ACTIVITY_TRACKING] = true;
            isTickedList[ListItem.EDITABLE] = true;
            break;
        case Types_1.ProjectStatus.Accepted:
            isTickedList[ListItem.ANYONE_CAN_ACCESS] = true;
            isTickedList[ListItem.ACTIVITY_TRACKING] = true;
            isTickedList[ListItem.EDITABLE] = false;
            break;
        case Types_1.ProjectStatus.Declined:
            isTickedList[ListItem.ANYONE_CAN_ACCESS] = false;
            isTickedList[ListItem.ACTIVITY_TRACKING] = false;
            isTickedList[ListItem.EDITABLE] = false;
            break;
        case Types_1.ProjectStatus.Draft:
            isTickedList[ListItem.ANYONE_CAN_ACCESS] = false;
            isTickedList[ListItem.ACTIVITY_TRACKING] = false;
            isTickedList[ListItem.EDITABLE] = true;
            break;
        default:
            throw Error("Unhandled page status (".concat(pageStatus, ") for Checklists component"));
    }
    return (react_1.default.createElement("div", { className: pageStateChecklist() },
        react_1.default.createElement(ChecklistLine, { listItem: ListItem.EDITABLE, ticked: isTickedList[ListItem.EDITABLE] }),
        react_1.default.createElement("hr", { className: pageStateChecklist("divider") }),
        react_1.default.createElement(ChecklistLine, { listItem: ListItem.ANYONE_CAN_ACCESS, ticked: isTickedList[ListItem.ANYONE_CAN_ACCESS] }),
        react_1.default.createElement("hr", { className: pageStateChecklist("divider") }),
        react_1.default.createElement(ChecklistLine, { listItem: ListItem.ACTIVITY_TRACKING, ticked: isTickedList[ListItem.ACTIVITY_TRACKING] })));
};
exports.PageStateChecklist = PageStateChecklist;
var ArchiveConfirmationChecklist = function () {
    return (react_1.default.createElement("div", { className: pageStateChecklist() },
        react_1.default.createElement(ChecklistLine, { listItem: ListItem.EDITABLE, ticked: true }),
        react_1.default.createElement("hr", { className: pageStateChecklist("divider") }),
        react_1.default.createElement(ChecklistLine, { listItem: ListItem.ANYONE_CAN_ACCESS, ticked: true }),
        react_1.default.createElement("hr", { className: pageStateChecklist("divider") }),
        react_1.default.createElement(ChecklistLine, { listItem: ListItem.ACTIVITY_TRACKING, ticked: false, descriptionOverride: "No tracking for analytics and reports" })));
};
exports.ArchiveConfirmationChecklist = ArchiveConfirmationChecklist;
var ChecklistLine = function (_a) {
    var listItem = _a.listItem, ticked = _a.ticked, descriptionOverride = _a.descriptionOverride;
    var _b = MapListItemToProps[listItem](ticked), description = _b.description, icon = _b.icon;
    return (react_1.default.createElement("div", { className: "checklist-line-container text-context-label" },
        icon,
        react_1.default.createElement("span", null, descriptionOverride !== null && descriptionOverride !== void 0 ? descriptionOverride : description)));
};
